import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-rubric-view-modal',
  templateUrl: './rubric-view-modal.component.html',
  styleUrls: ['./rubric-view-modal.component.css']
})
export class RubricViewModalComponent implements OnInit {

  @Input() get_rubric:any;
  @Input() max_points:any;
  @Input() negative_points:any;
  @Input() awarded_points:any;
    dataArry:any = []
  constructor() { }


   ngOnChanges() {
    console.log(this.get_rubric, this.max_points, this.negative_points, this.awarded_points);
  this.dataArry =  this.addMaxPoints(this.get_rubric);
  }

  ngOnInit() {
  }

    addMaxPoints(data) {
    data.forEach(item => {
      // Extract max points from stepsArray
      const maxPoints = Math.max(...item.option.stepsArray.map(step => parseFloat(step.points)));

      // Add a new key near selected_value
      item.topValue = maxPoints;
    });
    return data;
  }
  awardedMarksFormate(input){
    if (typeof input === 'undefined') {
      return '00.00'; // Return an empty string
    }
  
    const num = parseFloat(input);
    return num < 10 && input.length <= 4 ? `0${input}` : input;
   }

   
getPercentage(selectedValue: number, item: any): string {
  // const steps = item?.option?.stepsArray?.map(s => s.value) || [];
  const steps = (item && item.option && item.option.stepsArray)
  ? item.option.stepsArray.map(s => s.value)
  : [];
  const index = steps.indexOf(selectedValue);

  if (index === -1) return '0%';

  if (steps.length === 1) return '100%';

  const percent = (index / (steps.length - 1)) * 100;
  return percent + '%';
}

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/rubric-view-modal/rubric-view-modal.component.ts